import $ from 'jquery';

/* ================= Search Popup ================= */
theme.SearchPopup = (function () {
  // Products Grid
  const $gridTrigger = $('.more-search-results__trigger.grid-trigger');
  const $gridMore = $('.more-search-results__container.grid-cont');

  const $moreProducts = $('.search-result__more-products');

  $gridMore.hide();

  $gridTrigger.on('click', () => {
    $gridTrigger.toggleClass('active');
    $gridMore.slideToggle('slow');

    $moreProducts.slideToggle('slow');

    return false;
  });

  // Articles List
  const $listTrigger = $('.more-search-results__trigger.list-trigger');
  const $listMore = $('.more-search-results__container.list-cont');

  const $moreArticles = $('.search-result__more-articles');

  $listMore.hide();

  $listTrigger.on('click', () => {
    $listMore.slideToggle('slow');
    $listTrigger.toggleClass('active');

    $moreArticles.slideToggle('slow');

    return false;
  });
})();
